import { httpClient } from '../http-client/http-client';
import { apiConstants } from './apiConstants';

const referrersDetails = (shareCode) => {
  const url = apiConstants.referrersDetails;
  return httpClient.get(url + shareCode).then(result => result);
};


export { referrersDetails };
